import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Carousel, Image, Col, Container, Row, Spinner } from "react-bootstrap";
import {
  ShopProductCard,
  PageHeaderSection,
  FilterNavigation,
  ProductQuickView
} from "../components";
import { useTranslation } from "react-i18next";
import { RootState, AppDispatch } from "../redux/store";
import {
  loadProducts,
  setCategory
} from "../redux/slices/productListSlice";
import { setSelectedProduct } from "../redux/slices/productDetailSlice";
import { useInfiniteScroll, useWishlist, useCart } from "../hooks/";


import bg_05 from "./../images/Content/haeussler-job-01.webp";

import { Product } from "../interfaces/productInterface";

const Shop: React.FunctionComponent = () => {
  const { t } = useTranslation(["shop", "common"]);
  const { toggle, isInWishlist } = useWishlist()
  const { addItemToCart } = useCart();
  const dispatch = useDispatch<AppDispatch>();
  const [searchParams] = useSearchParams();

  const {
    products,
    page,
    hasMore,
    loading,
    category
  } = useSelector((state: RootState) => state.productList);

  const selectedCategory = searchParams.get("category") ?? "all";

  useEffect(() => {
    dispatch(setCategory(selectedCategory));
    dispatch(loadProducts({ category: selectedCategory === "all" ? undefined : selectedCategory, page: 0 }));
  }, [selectedCategory]);

  const loaderRef = useInfiniteScroll(() => {
    dispatch(
      loadProducts({
        category: category === null ? undefined : category,
        page
      })
    );
  }, hasMore, loading);

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "22px",
    lineHeight: "35px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  const categories = [
    { id: "all", name: "Alle" },
    { id: "bread", name: "Brote", icon: "/icons/bread.svg" },
    { id: "pastry", name: "Gebäck", icon: "/icons/pastry.svg" },
    { id: "cakes", name: "Kuchen", icon: "/icons/cake.svg" }
  ];

  return (
    <Container>
      <section style={{ marginBottom: "100px" }} id={"section_intro"}>
        <Carousel>
          <Carousel.Item>
            <Image src={bg_05} alt="First slide" fluid style={{ maxHeight: "65vh", width: "100%", objectFit: "cover" }} />
            <Carousel.Caption>
              <h3>First slide label</h3>
              <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <Image src={bg_05} alt="First slide" fluid style={{ maxHeight: "65vh", width: "100%", objectFit: "cover" }} />
            <Carousel.Caption>
              <h3>Second slide label</h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <Image src={bg_05} alt="First slide" fluid style={{ maxHeight: "65vh", width: "100%", objectFit: "cover" }} />
            <Carousel.Caption>
              <h3>Third slide label</h3>
              <p>
                Praesent commodo cursus magna, vel scelerisque nisl consectetur.
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
      </section>
      <section>
        <PageHeaderSection
          id="section_shop"
          headline={t("page_header.headline")}
          subheadline={t("page_header.subheadline")}
          content={<p style={{ fontSize: 22 }}>{t("page_header.content")}</p>}
        />

        <FilterNavigation
          categories={categories}
          activeCategory={selectedCategory}
          onSelectCategory={(catId) => {
            window.history.replaceState({}, "", `/shop?category=${catId}`);
          }}
        />

        <Row>
          {products.map((item, index) => (
            <Col xl={3} lg={4} md={6} sm={6} xs={12} key={index}>
              <ShopProductCard
                key={index}
                id={item.productId}
                name={item.name}
                price={Number(item.price)}
                oldPrice={undefined}
                image={'https://bhmm.de/api/v1/images/products/7cd7f82c16de05b7a29b4079b57f24a3'}
                discount={undefined}
                isNew={false}
                isInWishlist={isInWishlist(item.productId)}
                toggleWishlist={() => toggle(item.productId)}
                onClickProduct={() => dispatch(setSelectedProduct(item as unknown as Product))}
                onClickAddToCart={() => addItemToCart(item.productId, 1)}
              />
            </Col>
          ))}
        </Row>

        {loading && (
          <div className="text-center my-4">
            <Spinner animation="border" variant="warning" />
          </div>
        )}

        <div ref={loaderRef} />
      </section>
      <ProductQuickView />
    </Container>
  );
}

export default Shop;
